/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit, Input } from '@angular/core';
import { HomeComponent } from './home.component';
import 'rxjs/add/operator/first';

@Component({
    templateUrl: 'nota.component.html',
    styleUrls: ['home.component.css'],
    selector: 'nota-row',
})

export class NotaRowComponent extends HomeComponent implements OnInit {
    @Input() registro: any;
}